export function getAppInstanceToken(configId = '', host = '', appName = ''): string {
  return configId + '--' + host + '--' + appName;
}
